import React, { useState, useEffect } from "react";
import md5 from "md5";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper/core";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/swiper-bundle.css";
import "./Careers.css";
import DynamicBanner from "../include/DynamicBanner"; 
import api from "../../../api"; 
import toast from "react-hot-toast";

SwiperCore.use([Autoplay, Pagination]);

const Careers = () => {
  const [jobs, setJobs] = useState([]);
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  // Form fields
  const [firstName, setFirstName] = useState("");
  const [title, setTitle] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [experience, setExperience] = useState("");
  const [availability, setAvailability] = useState("");
  const [address, setAddress] = useState("");
  const [aadhaar, setAadhaar] = useState("");
  const[qualification,setQualification]=useState("");
  const[pancard,setPancard]=useState("");
  const [resumeFile, setResumeFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchJobs();
    fetchPageData();
  }, []);

  const formatPath = (path) => {
    if (!path) return null;
    return path.startsWith("/") ? path : `/${path}`;
  };

  /* ===== FETCH DYNAMIC PAGE CONTENT ===== */
  const fetchPageData = async () => {
    try {
      const response = await api.get('/api/sitepages/academic/careers'); 
      if (response.data?.status) {
        setPageData(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching Careers page data:", err);
    } finally {
      setLoading(false);
    }
  };

  /* ===== HRMS API KEY ===== */
  const generateApiKey = () => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
    const dateStr =
      now.getFullYear() +
      pad(now.getMonth() + 1) +
      pad(now.getDate()) +
      pad(now.getHours()) +
      pad(now.getMinutes());
    return md5(md5(`C@reHr!sjob#${dateStr}`));
  };

  /* ===== FETCH JOB LIST (KEEPING HRMS LOGIC) ===== */
  const fetchJobs = async () => {
    try {
      const formData = new FormData();
      formData.append("api_key", generateApiKey());
      const res = await fetch("https://hrms.care.edu.in/job_listing_json.php", { 
        method: "POST", 
        body: formData 
      });
      const json = await res.json();
      if (json.status === "success") {
        const mapped = json.data.map((job) => ({
          id: job.jobid,
          title: job.job_title,
          departmentname:job.departmentname,
          department: job.job_description ,
          experience: job.experience,
          last_date:job.last_date,
          posted: job.job_open_date,
          badge: "NEW",
          email: job.mailto,
          location:job.job_location,

        }));
        setJobs(mapped);
      }
    } catch (err) {
      console.error("Job API error:", err);
    }
  };

  const formatAadhaar = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 12);
    return digits.replace(/(\d{4})(?=\d)/g, "$1 ");
  };

  const isValidAadhaar = (value) => /^\d{4}\s\d{4}\s\d{4}$/.test(value);

  const isValidPAN = (pan) =>
  /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);

  


  const handleApplySubmit = async (e) => {
    e.preventDefault();
    if (!resumeFile) { toast.error("Please upload resume"); return; }
    if (!isValidAadhaar(aadhaar)) { toast.error("Aadhaar format: 1234 1234 1234"); return; }
    if (pancard && !isValidPAN(pancard.toUpperCase())) {
    toast.error("Invalid PAN format (ABCDE1234F)");
    return;
  }

    const fullFirstName = `${title} ${firstName}`.trim();
    setSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("api_key", generateApiKey());
      formData.append("post_applying_id", selectedJob.id);
      formData.append("first_name", fullFirstName);
      formData.append("last_name", lastName);
      formData.append("email", email);
      formData.append("mobile", mobile);
      formData.append("experience", experience);
      formData.append("communication_address", address);
      formData.append("aadhaar_number", aadhaar);
      formData.append("available_type", availability);
      formData.append("resume", resumeFile);
      formData.append("qualification", qualification);
      formData.append("pancard", pancard);


      const res = await fetch("https://hrms.care.edu.in/candidate_save_api.php", { 
        method: "POST", 
        body: formData 
      });
      const data = await res.json();
      if (data.status === "success") {
        toast.success("Application submitted successfully");
        setShowApplyModal(false);
        resetForm();
      } else {
        toast.error(data.message || "Submission failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  const resetForm = () => {
    setTitle(""); setFirstName(""); setLastName(""); setEmail("");
    setMobile(""); setExperience(""); setAvailability(""); setAddress("");
    setAadhaar(""); setResumeFile(null);
  };

  const getPostedTime = (dateStr) => {
    const diff = Math.floor((new Date() - new Date(dateStr)) / (1000 * 60 * 60 * 24));
    if (diff === 0) return "Posted today";
    if (diff === 1) return "Posted 1 day ago";
    if (diff < 7) return `Posted ${diff} days ago`;
    return "Posted recently";
  };
  
  const isTodayOrYesterday = (dateString) => {
    const today = new Date().toISOString().split("T")[0];
    const yesterday = new Date(Date.now() - 864e5).toISOString().split("T")[0];
    return dateString === today || dateString === yesterday;
  };

if (loading) return <div className="text-center py-5">Loading...</div>;
if (!pageData) return null;

// ✅ NORMALIZE FEATURE ITEMS (FIX .map ERROR)
const featureItems = Array.isArray(pageData?.feature_items)
  ? pageData.feature_items
  : pageData?.feature_items
  ? Object.values(pageData.feature_items)
  : [];


  return (
    <div className="job-listings-page">
      {/* SECTION 1: DYNAMIC BANNER WITH BUTTON FIX */}
      <DynamicBanner 
        title={pageData.banner_heading}
        bgImage={pageData.desktop_banners?.map(formatPath)}
        bgImageMobile={pageData.mobile_banners?.map(formatPath)}
        buttons={pageData.banner_buttons?.map(btn => ({
            link: btn.url,
            text: btn.name
        }))}
      />

      <div className="container pt-5">
        <div className="sec-title text-center pt-3">
          <h2>Openings</h2>
        </div>
        <div className="row">
          {jobs.length > 0 ? (
            jobs.map((job) => (
              <div className="col-md-4" key={job.id}>
               <div className="job-item">
                <div className="job-header">
                  <div className="job-content">

                    {/* TOP CONTENT */}
                    <div className="job-body">
                      <div className="campus-badge">
                        <i className="fa fa-university"></i> {job.location}
                      </div>

                      <h3 className="job-title">{job.title}</h3>
                      <p className="job-subtitle">{job.departmentname}</p>

                      <hr />

                      <ul className="job-details">
                        <li><i className="fa fa-check-circle"></i> <p><strong>Job Description :</strong> {job.department}</p></li>
                        <li><i className="fa fa-briefcase"></i> <p><strong>Job Experience :</strong> {job.experience}</p></li>
                        <li><i className="fa fa-calendar"></i> <p><strong>Last Date To Apply :</strong> {job.last_date}</p></li>
                      </ul>
                    </div>

                    {/* FOOTER (ALWAYS BOTTOM) */}
                 

                  </div>
                </div>
                   <div className="job-footer">
                      <div className="job-posted-time">{getPostedTime(job.posted)}</div>
                      <button
                        className="job-apply-btn"
                        onClick={() => {
                          setSelectedJob(job);
                          setShowApplyModal(true);
                        }}
                      >
                        Apply Now
                      </button>
                    </div>
</div>

              </div>
            ))
          ) : (
            <p className="text-center w-100">No jobs available</p>
          )}
        </div>
      </div>

      {/* ===== APPLY MODAL (DYNAMIC HEADING) ===== */}
      {showApplyModal && (
        <div className="modal-backdrop-custom">
          <div className="apply-modal">
            <h4 className="mb-4">
              {pageData.apply_form_heading || "Apply for"}: <span>{selectedJob?.title}</span>
            </h4>
            <form onSubmit={handleApplySubmit}>
              <div className="row">
                <div className="col-md-2">
                  <div className="mb-2">
                    <label className="form-label d-block">Title <span className="text-danger">*</span></label>
                    <select className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} required>
                      <option value="">Select</option>
                      <option value="Mr">Mr</option><option value="Mrs">Mrs</option><option value="Miss">Miss</option><option value="Dr">Dr</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="mb-2">
                    <label className="form-label d-block">First Name <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="mb-2">
                    <label className="form-label d-block">Last Name</label>
                    <input type="text" className="form-control" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-2">
                    <label className="form-label d-block">Email <span className="text-danger">*</span></label>
                    <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-2">
                    <label className="form-label d-block">Mobile <span className="text-danger">*</span></label>
                    <input type="tel" className="form-control" value={mobile} onChange={(e) => setMobile(e.target.value)} required />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-2">
                    <label className="form-label d-block">Experience <span className="text-danger">*</span></label>
                    <select className="form-control" value={experience} onChange={(e) => setExperience(e.target.value)} required>
                      <option value="">Select</option><option value="fresher">Fresher</option><option value="1-2">1–2 Yrs</option><option value="2-3">2–3 Yrs</option><option value="3-5">3–5 Yrs</option><option value="5+">5+ Yrs</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-2">
                    <label className="form-label d-block">Availability <span className="text-danger">*</span></label>
                    <select className="form-control" value={availability} onChange={(e) => setAvailability(e.target.value)} required>
                      <option value="">Select</option><option value="immediate">Immediate</option><option value="15days">15 Days</option><option value="1month">1 Month</option><option value="3months">3 Months</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-2">
                    <label className="form-label d-block">Aadhaar Number <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" value={aadhaar} onChange={(e) => setAadhaar(formatAadhaar(e.target.value))} maxLength={14} required />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-2">
                    <label className="form-label d-block">Qualification <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" value={qualification} onChange={(e) => setQualification(e.target.value)}   required />
                  </div>
                </div>

                 <div className="col-md-6">
                  <div className="mb-2">
                    <label className="form-label d-block">Pan Card </label>
                    <input type="text" className="form-control" value={pancard} onChange={(e) => setPancard(e.target.value)}   maxLength={10}/>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-2">
                    <label className="form-label d-block">Address <span className="text-danger">*</span></label>
                    <textarea className="form-control" rows="4" value={address} onChange={(e) => setAddress(e.target.value)} required />
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <label className="form-label d-block">Upload Resume <span className="text-danger">*</span></label>
                <input type="file" className="form-control" accept=".pdf,.doc,.docx" onChange={(e) => setResumeFile(e.target.files[0])} required />
              </div>
              <div className="d-flex justify-content-between mt-4">
                <button type="button" className="btn btn-secondary" onClick={() => { setShowApplyModal(false); resetForm(); }}>Cancel</button>
                <button type="submit" className="btn btn-success" disabled={submitting}>{submitting ? "Applying..." : "Apply Now"}</button>
              </div>
            </form>
          </div>
        </div>
      )} 

      {/* SECTION 3: STATS (DYNAMIC) */}
      <section className="stats-section d-md-block d-none">
        <div className="stats-wrapper">
         {featureItems.map((item, idx) => (
            <div className="stat-card" key={idx}>
              <div className="stat-number">{item.count}</div>
              <div className="stat-title">{item.heading}</div>
              <div className="text-muted small">{item.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* MOBILE STATS */}
      <section className="stats-section d-block d-md-none m-4">
                <Swiper
                  slidesPerView={1}
                  spaceBetween={20}
                  loop={true}
                  autoplay={{ delay: 3000 }}
                  pagination={{ clickable: true }}
                >
                  {featureItems.map((item, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="stat-card">
                        <div className="stat-number">{item.count}</div>
                        <div className="stat-title">{item.heading}</div>
                        <div>{item.desc}</div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </section>


      {/* SECTION 4: CONTACT (DYNAMIC) */}
      {/* <section className="get-in-touch-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">{pageData.contact_heading}</h2>
          </div>
          <div className="row contact-container">
            <div className="col-lg-6 col-md-12 mb-3 mb-md-0">
              <div className="location-card">
                <div className="location-icon"><i className={pageData.contact_icon || "fa fa-map-marker"}></i></div>
                <h3 className="location-title">{pageData.location_heading}</h3>
                <div className="location-address" style={{ whiteSpace: 'pre-line' }}>{pageData.location_address}</div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 divider">
              <div className="contact-card-careers">
                {pageData.contact_list?.map((contact, idx) => (
                  <div className="contact-item-careers" key={idx}>
                    <div className={`contact-icon ${idx % 2 === 0 ? 'phone-icon' : 'email-icon'}`}><i className={contact.icon}></i></div>
                    <div className="contact-info">
                      <div className="contact-title">{contact.heading}</div>
                      <p className="contact-detail">
                        <a href={contact.value.includes('@') ? `mailto:${contact.value}` : `tel:${contact.value}`}>{contact.value}</a>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Careers;